<template>
  <div class="layout-wrapper layout-menu-light layout-topbar-lightblue bg-white">
    <div class="layout-topbar shadow-4">
      <div class="layout-topbar-left">
        <router-link class="layout-topbar-logo" to="/">
          <img id="logo" src="/layout/images/152.png" alt="ultima-layout" style="height: 3.55rem">
        </router-link>
        <div v-if="isWrapped" style="position: absolute; right: 0;" class="pr-4">
          <ul  class="layout-topbar-items">
            <li class="flex layout-topbar-item ">
              <a class="layout-topbar-action rounded-circle p-ripple" aria-haspopup="true" aria-controls="overlay_menu"
                 @click="toggle"
                 v-ripple>
                <i class="pi pi-globe fs-large"></i>
              </a>
              <Menu ref="menu" :model="items" :popup="true"/>

            </li>
          </ul>
        </div>
      </div>

      <div class="layout-topbar-right" :style="{'top: 7rem; height: calc(100% - 7rem);': isWrapped}"
           :class="{'layout-topbar-mobile-active': isWrapped}">
        <div v-if="!isWrapped" class="layout-topbar-actions-left">

        </div>
        <div v-if="!isWrapped" class="layout-topbar-actions-right">
          <ul class="layout-topbar-items">
            <li class="layout-topbar-item">
              <a class="layout-topbar-action rounded-circle p-ripple" aria-haspopup="true" aria-controls="overlay_menu"
                 @click="toggle"
                 v-ripple>
                <i class="pi pi-globe fs-large"></i>
              </a>
              <Menu ref="menu" :model="items" :popup="true"/>

            </li>
          </ul>

        </div>
      </div>
    </div>

    <div class="layout-main">
      <div class="container">

        <div class="flex flex-column align-items-center justify-content-center">
          <div class="pages-header" style="margin: 50px auto 0;">
            <h3>{{ $t('auth') }}</h3>
          </div>
          <tabView style="    min-height: 668px;" class="a_tab">
            <tabPanel :header="$t('id/pass')">
              <div class="mt-1 flex flex-column align-items-center justify-content-center">

                <div class="align-self-center mt-auto mb-auto">
                  <div class="pages-panel flex flex-column">

                    <div class="mt-3 col-12">
                      <form @submit="login">

                        <div class="formgrid grid">
                          <div class="field p-fluid  col-12">

                <span class="p-float-label">

                <InputMask id="inputmask" type="text" class="p-inputtext-lg" autocomplete="id" required
                           v-model="user.uid" mask="9999 9 9999"/>
                            <label for="inputmask">ID</label>

                        </span>
                            <small class="text-gray-600">{{ $t('Enter your ID.') }}</small>
                          </div>

                          <div class="field p-fluid col-12">

            <span class="p-float-label">
                        <InputText type="password"
                                   name="password"
                                   autocomplete="current-password"
                                   required
                                   class="p-inputtext-lg"
                                   v-model="user.password"
                                   id="password"/>
                        <label for="password">{{ $t('Password') }}</label>
                    </span>
                            <small class="text-gray-600">{{ $t('Enter your password.') }}</small>

                          </div>
                        </div>


                        <Button label="Submit" @click="login" :loading="loading" iconPos="right"
                                class="mt-3 p-button-lg p-button-raised w-full"></Button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </tabPanel>

            <tabPanel :header="$t('QR code')">
              <div class="form-group">
                <div v-if="!qrCodeScanned">
                  <p>Please scan the QR code with your device camera to login.</p>
                  <img :src="qrCodeUrl" alt="QR code for login">
                </div>
                <div v-else>
                  <p>Login successful.</p>
                </div>
              </div>
            </tabPanel>
            <tabPanel :disabled="true" :header="$t('SSH Key')">
              <form>
                <div class="form-group">
                  <label for="sshKey">SSH Key:</label>
                  <textarea v-model="sshKey" class="form-control" id="sshKey" placeholder="Enter SSH Key"></textarea>
                </div>
                <button type="submit" class="btn btn-primary" @click="loginWithSSHKey">Login</button>
              </form>
            </tabPanel>
          </tabView>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import {computed, ref} from "vue";
import i18n, {supportedLocales} from "@/locales/i18n";
import {useRoute, useRouter} from "vue-router";
import store from "@/store";

const menu = ref();
const qrCodeScanned = ref(false);
const qrCodeUrl = ref('');
const sshKey = ref('');
const windowWidth = ref(window.innerWidth);
const user = ref({
  uid: "",
  password: "",
});
const router = useRouter()
const route = useRoute()
window.addEventListener('resize', () => {
  windowWidth.value = window.innerWidth
})

let loading = ref(false);

function login(ev) {
  ev.preventDefault();
  user.value.uid = user.value.uid.replace(/\s/g, '');
  loading.value = true;
  let _this = this
  store
    .dispatch("login", user.value)
    .then(() => {
      loading.value = false;
      router.push({
        name: "chart",
      });
    })
    .catch((err) => {
      loading.value = false;
      _this.$toast.add({severity: 'error', summary: 'Error Message', detail: err.response.data.error, life: 30000});
    });
}

function loginWithSSHKey() {
}

const isWrapped = computed(() => windowWidth.value <= 991);

function formatLanguageObject(obj) {
  let result = [];
  for (let key in obj) {
    let lang = obj[key];
    result.push({
      label: lang.name,
      command: () => {
        changeLocale(key)
      }
    });
  }
  return result;
}

function changeLocale(val) {
  i18n.setLocale(val);
  router.push({...route, params: {...route.params, locale: val}});
}

function toggle(event) {
  menu.value.toggle(event);
}

const items = ref([
  ...formatLanguageObject(supportedLocales),
])

</script>
<style>

.a_tab {
  min-height: 524px;
  height: auto;
  margin-top: 50px;
  margin-bottom: 15px;
}

</style>
